import styled from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${DEFAULT_COLORS.white};
  border-bottom: 1px solid ${DEFAULT_COLORS.sky.borderLight};
  padding: 1.25rem;
  border-radius: 4px 4px 0 0;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  font-weight: 500;
  color: ${DEFAULT_COLORS.ink.base};
  margin: 0;
  padding-left: 1rem;
`;

export const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0.375rem;
  background: ${DEFAULT_COLORS.white};
  border: 1px solid ${DEFAULT_COLORS.surface.subtle};
  padding: 0 1rem;
  width: 24rem;
  height: 2.75rem;
`;

export const SearchIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${DEFAULT_COLORS.sky.muted};
`;

export const SearchInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  font-size: 0.875rem;
  color: ${DEFAULT_COLORS.ink.base};
  padding-left: 0.5rem;

  &::placeholder {
    color: ${DEFAULT_COLORS.sky.muted};
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
